import { IconCornerDesktop } from "app/components/Icon/Icon";
import React from "react";
export const PopularEventCellStats = (
  props: Record<string, any>
): React.JSX.Element => {
  return (
    <div className="popular-event-cell__stats">
      <div className="popular-event-cell__stats__icons">
        <div className="popular-event-cell__stats__icons--yellow-cards" />
        <div className="popular-event-cell__stats__icons--red-cards" />
        <div className="popular-event-cell__stats__icons--corners-icon">
          <IconCornerDesktop />
        </div>
      </div>
    </div>
  );
};
export default PopularEventCellStats;
